import React from "react";
//useFetch hook
import useFetch from "../hooks/useFetch";
// link
import { Link } from "react-router-dom";
const CategoryNav = () => {
  const { data } = useFetch("/categories");

  return <aside className="hidden xl:flex">
    <div className="bg-primary flex flex-col w-[286px] h-[500] rounded-[8px] overflow-hidden">
      <div className="bg-[#f24a04] py-4 text-white uppercase font-semibold flex items-center justify-center">Browser Categories</div>
      <div className="flex flex-col gap-y-6 p-6">
        {data?.map((category)=>{
          return<Link to={`/products/${category.id}`} className="cursor-pointer uppercase" key={category.id}>{category.title}</Link>
        })}
      </div>
    </div>
  </aside>;
};

export default CategoryNav;
